import React, { Fragment, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Constants

import externalEndpoints from '../../../../../constants/configs/externalEndpoints';

// Types

import { IsState } from '../../../SsapTypes';

interface VoterAndOrganDonorInformation {
    exchangeName: string,
    isState: IsState,
    REGISTER_FOR_VOTE: string
}

const VoterAndOrganDonorInformation = (props: VoterAndOrganDonorInformation): ReactElement | null => {
    const {
        exchangeName,
        isState,
        REGISTER_FOR_VOTE
    } = props;

    const getInformation = (): JSX.Element | null => {
        switch(true) {
            case isState.NJ:
                return (
                    <Fragment>
                        <FormattedMessage
                            id = 'ssap.sign_and_review.if_you_are_not_registered'
                            tagName = 'p'
                        />
                        <a
                            className = 'usa-link--external'
                            href = { `https://${ REGISTER_FOR_VOTE }` }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            { `https://${ REGISTER_FOR_VOTE }` }
                        </a>
                    </Fragment>
                );
            case isState.PA:
            case isState.IL:
                return (
                    <Fragment>
                        <FormattedMessage
                            id = 'ssap.sign_and_review.if_you_are_not_registered'
                            tagName = 'p'
                            values = { {
                                register: (
                                    <strong>
                                        <FormattedMessage id = 'ssap.sign_and_review.register' />
                                    </strong>
                                ),
                                update: (
                                    <strong>
                                        <FormattedMessage id = 'ssap.sign_and_review.update' />
                                    </strong>
                                )
                            } }
                        />
                        <a
                            className = 'usa-link--external'
                            id='voter_registration_link'
                            href = { externalEndpoints.PA_LINKS.VOTER_REGISTRATION }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            { externalEndpoints.PA_LINKS.VOTER_REGISTRATION }
                        </a>
                        <FormattedMessage
                            id = 'ssap.sign_and_review.vote_registration_note'
                            tagName = 'p'
                            values = { {
                                exchangeName,
                                note: (
                                    <strong>
                                        <FormattedMessage id='ssap.sign_and_review.note' />
                                    </strong>
                                ),
                                voluntary: (
                                    <strong>
                                        <FormattedMessage id='ssap.sign_and_review.voluntary' />
                                    </strong>
                                )
                            } }
                        />
                        <FormattedMessage
                            id = 'ssap.sign_and_review.if_you_are_not_registered_organ_donor'
                            tagName = 'p'
                            values = { {
                                register: (
                                    <strong>
                                        <FormattedMessage id='ssap.sign_and_review.register' />
                                    </strong>
                                )
                            } }
                        />
                        <a
                            className = 'usa-link--external'
                            id='organ_donor_registration_link'
                            href = { externalEndpoints.PA_LINKS.ORGAN_DONOR_REGISTRATION }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            { externalEndpoints.PA_LINKS.ORGAN_DONOR_REGISTRATION }
                        </a>
                        <FormattedMessage
                            id = 'ssap.sign_and_review.organ_donor_registration_note'
                            tagName = 'p'
                            values = { {
                                exchangeName,
                                note: (
                                    <strong>
                                        <FormattedMessage id='ssap.sign_and_review.note' />
                                    </strong>
                                ),
                                voluntary: (
                                    <strong>
                                        <FormattedMessage id='ssap.sign_and_review.voluntary' />
                                    </strong>
                                )
                            } }
                        />
                    </Fragment>
                );
            default:
                return null;
        }
    };

    return getInformation();
};

export default VoterAndOrganDonorInformation;